import {
  API,
  axios,
  SendRequest,
  toastr,
} from "@/imports-files/pages/clients/activities/client-integrations";

export class CompanyIntegrationService extends SendRequest {
  async applyFilter(params) {
    const url = API.client.activities.CLIENT_INTEGRATIONS_URL;
    try {
      const transformedParams = Object.keys(params).filter(
        (key) => params[key] === true && key
      );
      const result = await axios.get(
        url,
        {
          params: { integration_category: transformedParams },
          headers: this.customHeaderJSON(),
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON()
      );
      return result;
    } catch (error) {
      return error;
    }
  }

  async applyClientFilter(params, client_id) {
    const url =
      API.admins.dashboard.clients.integration.CLIENT_INTEGRATIONS_URL.replace(
        "$client_id",
        client_id
      );
    try {
      const transformedParams = Object.keys(params).filter(
        (key) => params[key] === true && key
      );
      const result = await axios.get(
        url,
        {
          params: { integration_category: transformedParams },
          headers: this.customHeaderJSON(),
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON()
      );
      return result;
    } catch (error) {
      return error;
    }
  }
}
